$(document).on("turbolinks:load", function() {
  var cadenceSelect = $('#safety_video_list_cadence');
  if (!cadenceSelect.length) return;

  var weekdayField = $('#scheduled-weekday-field');
  var dayOfMonthField = $('#scheduled-day-of-month-field');

  function toggleScheduleFields() {
    var weekly = cadenceSelect.val() === 'weekly';
    weekdayField.toggle(weekly);
    dayOfMonthField.toggle(!weekly);
  }

  cadenceSelect.on('change', toggleScheduleFields);
  toggleScheduleFields();
});
